export default __webpack_public_path__ + "static/media/portfolio-lg-1.17c3ad1c.webp";